import React from 'react';
import axios from "../../../containers/api";
import DatePicker, {utils} from 'react-modern-calendar-datepicker';
import { Link } from "react-router-dom";
import Mapir from "mapir-react-component";
import polyline from "google-polyline";
import {Table} from "../../../components/table/Table";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {convertDate, getkalas, getLoaderTypes, getBastebandys, showCatchError, toEnglishNumbers, toCurrency, getDurationHour, getDayBefore} from "../../../helpers/Utils";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import {Button, Card, CardBody, Collapse, Input, ModalBody, Modal, ModalHeader, Row, Alert, InputGroupAddon, InputGroup, FormGroup, Label, CustomInput, ModalFooter} from "reactstrap";
import Config from "../../../constants/config";
import "../../../assets/css/sass/maps.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import AddCustomerModal from "../../info-base/customer/components/AddCustomerModal";
import EditCustomer from "../../info-base/customer/components/EditCustomer";
import Customer from "../../info-base/customer/Customer";

const Map = Mapir.setToken({
    transformRequest: url => {
        return {
            url: url,
            headers: {
                "x-api-key": Config.mapIrToken,
                "Mapir-SDK": "reactjs"
            }
        };
    }
});

class AddCargo extends React.Component {

    constructor(props) {
        super(props);
        this.mapContainer = React.createRef();
        this.cargoSource = React.createRef();
        this.cargoDestination = React.createRef();

        this.state = {
           
            specificLoad: false,
            customer: [],
            searchValue: "",
            sender: null,
            senderAddresses: [],
            senderAddress: null,
            receiver: null,
            receiverAddresses: [],
            receiverAddress: null,
             
             
            FutureDate: utils('fa').getToday(),
            FutureMinute: "",
            FutureHour: "",
             
            cargoRange: 2000,
            kalaValue: null,
            Tel: "",
            kala: null,
            Bastebandy: null,
            freighterNumber: 1,   
            bastebandyNumber: 1, 
            kalaWeight: null, 
            cargoRent: null,  
            description: null, 
            selectedLoaderTypes: [],
            map: null,
            cargoSource: "",
            cargoDestination: "",
            cargoDistance: "",
            cargoDuration: "",
            cargoSourceLat: "",
            cargoSourceLong: "",
            cargoDestinationLat: "",
            cargoDestinationLong: "",

            SourceAddress: "",
            SourcePostalcode: "",
            DestinationAddress: "",
            DestinationPostalcode: "",
            CompanyPrice: 0,
            SazmanPrice:0,
            Bimeprice:0,
            TotalPrice:0,
            
            searchBox1: null,
            searchBox2: null,
            geoCoder: null,
            isPishElamBar: false,
            pishElamBarName: "",
          
            errors: [],
            errorInputs: [],
            preLoads: null,
            copyLoadModal: false,
            load: [],
            loadsSearchModal: false,
            fromDate: getDayBefore(),
            toDate: utils('fa').getToday(),
            senders: [],
            receivers: [],
            
            selectedkalas: [],
            loadsSearchResult: [],
            accordion1: false,
            accordion2: false,
            iranmap: Config.IsMapIr,
            OriginCities: [],
            geojson: null,
               
            
            addCustomerModal: false,
            editCustomerModal: false,
            manageCustomerModal: false,
            manageCustomersModal: false,
            senderOptionsMenu: null,
            receiverOptionsMenu: null,
            currentCustomer: [],

            Bastebandys: [],
            kalas: [],
            loaderTypes: [],
            provinces: [],
            TransportationCompanyList: [],
            TransportationCompany: null,
        };
    }

    componentDidMount() {
        /* this.checkPermission();*/
        //this.LastLoadRange();
        const current = new Date(); 
        const time = current.toLocaleTimeString("fa-IR"); 
        this.setState({
            FutureMinute: (time !== null && time !== undefined && time !== "") ? time.split(':')[1].length === 1 ? toEnglishNumbers(0) + toEnglishNumbers(time.split(':')[1]) : toEnglishNumbers(time.split(':')[1]) : "",
                FutureHour: (time !== null && time !== undefined && time !== "") ? time.split(':')[0].length === 1 ? toEnglishNumbers(0) + toEnglishNumbers(time.split(':')[0]) : toEnglishNumbers(time.split(':')[0]) : "",
        })

        try {
            this.getBastebandysApi().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }
        try {
            this.getkalasApi().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }
        try {
            this.getLoaderTypesApi().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }

        this.GetCustomerByTransportationCompanyId();
       
        this.GetAllTransportationCompany();
        
    }
    
    checkPermission = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/HasAccessTo?permissionName=Load_Add')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data) {
                    this.LastLoadRange();

                    // initializing the google map
                    
                    try {
                        this.getBastebandysApi().then(r => console.log(r));
                    } catch (err) {
                        console.log(err);
                    }
                    try {
                        this.getkalasApi().then(r => console.log(r));
                    } catch (err) {
                        console.log(err);
                    }
                    try {
                        this.getLoaderTypesApi().then(r => console.log(r));
                    } catch (err) {
                        console.log(err);
                    }

                    this.GetCustomerByTransportationCompanyId();
                     
                    
                } else {
                    this.props.history.push('/error404');
                }
            })
            .catch((error) => {
                console.log(error)
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    LastLoadRange = () => {
        this.props.showSpinner();
        axios.get('api/LoadApi/LastLoadrange')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({cargoRange: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    //google maps:
   
    setOrigin = () => {
        let place1 = this.state.searchBox1.getPlaces()[0];
        if (place1.hasOwnProperty("geometry")) {
            this.setState({cargoSource: place1.name});
            this.setState({cargoSourceLat: place1.geometry.location.lat()});
            this.setState({cargoSourceLong: place1.geometry.location.lng()},
                () => this.routing());
            this.state.map.fitBounds(place1.geometry.viewport);
            new window.google.maps.Marker({
                position: {lat: this.state.cargoSourceLat, lng: this.state.cargoSourceLong},
                map: this.state.map,
                title: "مبدا"
            });
        } else {
            this.props.showAlert('مکان انتخاب شده صحیح نیست! لطفا هنگام جستجو از روی لیست پیشنهادی بر روی گزینه مورد نظر خود کلیک کنید', "error");
        }
    };
    routing = () => {
        if (this.state.cargoSourceLat && this.state.cargoSourceLong && this.state.cargoDestinationLat && this.state.cargoDestinationLong) {
            
                let cargoDuration = this.state.cargoSourceLong + "," + this.state.cargoSourceLat + ";" + this.state.cargoDestinationLong + "," + this.state.cargoDestinationLat;
                fetch("https://map.ir/eta/driving/" + cargoDuration,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "x-api-key": Config.mapIrToken,
                        }
                    }
                )
                    .then(res => res.json())
                    .then(result => {
                      
                        let dd = getDurationHour(result.routes.distance, result.routes.duration)
                        this.setState({ cargoDuration: dd.hour });
                        this.setState({ cargoDistance: dd.kilometer +" کیلومتر"});
                    });
            
        }
    };
    setDestination = () => {
        let place2 = this.state.searchBox2.getPlaces()[0];
        if (place2.hasOwnProperty("geometry")) {
            this.setState({cargoDestination: place2.name});
            this.state.map.fitBounds(place2.geometry.viewport);
            this.setState({cargoDestinationLat: place2.geometry.location.lat()});
            this.setState({cargoDestinationLong: place2.geometry.location.lng()},
                () => this.routing());
            new window.google.maps.Marker({
                position: {lat: this.state.cargoDestinationLat, lng: this.state.cargoDestinationLong},
                map: this.state.map,
                title: "مقصد"
            });
        } else {
            this.props.showAlert('مکان انتخاب شده صحیح نیست! لطفا هنگام جستجو از روی لیست پیشنهادی بر روی گزینه مورد نظر خود کلیک کنید', "error");
        }
    };

    async getBastebandysApi() {
        try {
            await getBastebandys()
                .then((res) => this.setState({ Bastebandys:  res.data }) );
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({kalas: res.data}) );
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    async getLoaderTypesApi() {
        try {
            await getLoaderTypes()
                .then((res) => this.setState({loaderTypes: res.data}) );
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
     
    GetCustomerByTransportationCompanyId = () => {
        axios.get('/api/v1/Customer/GetCustomerByTransportationCompanyId')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ customer: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
     
    copyLoad = () => {
        if (this.state.preLoads) {
            this.setState({copyLoadModal: !this.state.copyLoadModal});
        } else {
            this.getPreLoads(() => this.setState({copyLoadModal: !this.state.copyLoadModal}));
        }
    }
    getPreLoads = (callback) => {
        this.props.showSpinner();
        axios.get('api/LoadApi/GetPreLoads')
            .then((res) => {
                this.setState({preLoads: res.data}, () => {
                    if (callback !== undefined) {
                        callback();
                    }
                    this.props.hideSpinner();
                });
            })
            .catch((error) => {
                this.props.hideSpinner()
                this.props.showAlert(showCatchError(error));
            });
    };

    replaceData = (loadItem) => {
        if (loadItem.load.customerAddress !== null) {
            this.setState({sender: this.state.customer.filter((customer) => customer.customerInfoId === loadItem.load.customerAddress.customersInfoID ? customer : null)[0]},
                () => this.loadSenderAddresses(loadItem.load.customerAddress.customersInfo.customersInfoID, loadItem.load.senderAddressId));
            this.setState({receiver: this.state.customer.filter((customer) => customer.customerInfoId === loadItem.load.customerAddress1.customersInfoID ? customer : null)[0]},
                () => this.loadReceiverAddresses(loadItem.load.customerAddress1.customersInfo.customersInfoID, loadItem.load.receiverAddressId));

            this.setState({
              
                senderAddress: loadItem.load.customerAddress,
                receiverAddress: loadItem.load.customerAddress1
            });
        } else {
            this.setState({
                
                sender: null,
                receiver: null,
                senderAddress: null,
                receiverAddress: null,
                receiverAddresses: [],
                senderAddresses: []
            });
        }

        if (  loadItem.load.cargoRent != null) {
            this.setState({ 
                cargoRent: loadItem.load.cargoRent
            });
        }  
        this.setState({
           
            freighterNumber: loadItem.load.loadNumber, 
            kalaValue: loadItem.load.kalaValue,
            Tel: loadItem.load.tel,
            cargoSource: loadItem.load.loadSource,
            cargoDestination: loadItem.load.loadDestination,
            kala: loadItem.load.kala,
            Bastebandy: loadItem.load.Bastebandy, 
            kalaWeight: loadItem.load.kalaWeight,  
            description: loadItem.load.description, 
            selectedLoaderTypes: loadItem.loaderTypes,
            cargoSourceLat: loadItem.load.loadSourceLat,
            cargoSourceLong: loadItem.load.loadSourceLong,
            cargoDestinationLat: loadItem.load.loadDestinationLat,
            cargoDestinationLong: loadItem.load.loadDestinationLong,
            cargoDuration: loadItem.load.loadDuration,
            cargoDistance: loadItem.load.loadDistance,
            bastebandyNumber: loadItem.load.bastebandyNumber, 
        }, () => this.routing());
         
        this.props.showAlert("با موفقیت جایگزین شد", "success");
    };
    loadSenderAddresses = (selectedId, SenderAddressId) => {
        if (selectedId) {
            axios.get('/api/v1/CustomerAddress/GetCustomerAddressByCustomerId?CustomerId=' + selectedId)
                .then((res) => {
                    if (res.data.data != null && res.data.data.length > 0) {
                        if (SenderAddressId != null) {
                            this.setState({senderAddresses: res.data.data},
                                () => res.data.data.map((v) => {
                                    if (v.id === SenderAddressId) {
                                        this.setState({senderAddress: v},
                                            () => this.setState({ Origin: this.state.senderAddress.cityName },
                                                () => this.getOriginGeocode()))
                                    }
                                    return null
                                }));
                        } else {
                            this.setState({ senderAddresses: res.data.data },
                                () => this.setState({senderAddress: this.state.senderAddresses[0]},
                                    () => this.setState({cargoSource: this.state.senderAddress.cityName},
                                        () => this.getOriginGeocode()))
                            );
                        }
                    } else {
                        this.setState({
                            senderAddresses: [],
                            senderAddress: null,
                            cargoSourceLat: null,
                            cargoSourceLong: null,
                            cargoSource: ""
                        })
                    }
                })
                .catch((error) => {
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };
    loadReceiverAddresses = (selectedId, ReceiverAddressId) => {
        if (selectedId) {
            axios.get('/api/v1/CustomerAddress/GetCustomerAddressByCustomerId?CustomerId=' + selectedId)
                .then((res) => {
                    if (res.data != null && res.data.data.length > 0) {
                        if (ReceiverAddressId != null) {
                            this.setState({ receiverAddresses: res.data.data },
                                () => res.data.data.map((v) => {
                                    if (v.id === ReceiverAddressId) {
                                        this.setState({receiverAddress: v},
                                            () => this.setState({Destination: this.state.receiverAddress.cityName},
                                                () => this.getDestinationGeocode()))
                                    }
                                    return null
                                }));
                        } else {
                            this.setState({ receiverAddresses: res.data.data },
                                () => this.setState({receiverAddress: this.state.receiverAddresses[0]},
                                    () => this.setState({cargoDestination: this.state.receiverAddress.cityName},
                                        () => this.getDestinationGeocode()))
                            );
                        }
                    } else {
                        this.setState({
                            receiverAddresses: [],
                            receiverAddress: null,
                            cargoDestinationLat: null,
                            cargoDestinationLong: null,
                            cargoDestination: ""
                        })
                    }
                })
                .catch((error) => {
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };
    getOriginGeocode = () => {
        
            this.getCityOrigin();
        
    };
    getCityOrigin = () => {
        this.setState({OriginCities: []});

        let data = JSON.stringify({"text": this.state.cargoSource, "$select": "city"});
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "x-api-key": Config.xApiKey
            },
            body: data
        };

        fetch('https://map.ir/search/v2/autocomplete', requestOptions)
            .then(response => response.json())
            .then((data) => {
                if (data.value !== undefined) {
                    this.setState({OriginCities: data.value[0]})
                    this.setState({cargoSourceLat: data.value[0].geom.coordinates[1]});
                    this.setState({cargoSourceLong: data.value[0].geom.coordinates[0]},
                        () => this.routing());
                } else {
                    this.setState({OriginCities: []});
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert("خطا در برقراری ارتباط", "error");
            });
    };
    getDestinationGeocode = () => {
        this.getCityDestination();
    };
    getCityDestination = () => {
        this.setState({OriginCities: []});

        let data = JSON.stringify({"text": this.state.cargoDestination, "$select": "city"});
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "x-api-key": Config.xApiKey
            },
            body: data
        };
        fetch('https://map.ir/search/v2/autocomplete', requestOptions)
            .then(response => response.json())
            .then((data) => {
                if (data.value !== undefined) {
                    this.setState({OriginCities: data.value[0]});
                    this.setState({cargoDestinationLat: data.value[0].geom.coordinates[1]});
                    this.setState({cargoDestinationLong: data.value[0].geom.coordinates[0]},
                        () => this.routing());
                    this.setState({geojson: {}});
                    this.getDriverLocations(data.value[0].geom.coordinates[0], data.value[0].geom.coordinates[1]);
                } else {
                    this.setState({OriginCities: []});
                }
            }).catch((error) => {
            this.props.hideSpinner();
            this.props.showAlert("خطا در برقراری ارتباط", "error");
        });
    };
    getDriverLocations = (cargoDestinationLong, cargoDestinationLat) => {
        let lnglon = this.state.cargoSourceLong + "," + this.state.cargoSourceLat + ";" + cargoDestinationLong + "," + cargoDestinationLat;

        fetch("https://map.ir/routes/route/v1/driving/" + lnglon + "?overview=full",
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": Config.mapIrToken,
                }
            }
        )
            .then(res => res.json())
            .then(result => {
                let decodeResult = polyline.decode(result.routes[0].geometry);
                let reverseLatLon = decodeResult.map(items => items.reverse());
                let geojsonpoint = {
                    type: "FeatureCollection",
                    features: [
                        {
                            type: "Feature",
                            properties: {},
                            geometry: {
                                type: "LineString",
                                coordinates: reverseLatLon
                            }
                        }
                    ]
                };

                this.setState({geojson: geojsonpoint});
            });
    }; 
    delete = (loadId) => {
        this.props.showSpinner();

        axios.get('api/LoadApi/Delete?loadId=' + loadId)
            .then(() => {
                this.props.showAlert("پیش اعلام بار با موفقیت حذف شد!", "success");
                this.props.hideSpinner();
                this.getPreLoads();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    }; 
    searchLoad = () => {
        let searchModel = {
            FromDate: convertDate(this.state.fromDate),
            ToDate: convertDate(this.state.toDate),
            SenderId: [],
            ReceiverId: [],
            
            kalaId: []
        };

        if (this.state.receivers !== null) {
            this.state.receivers.map((receiver) =>
                searchModel.ReceiverId.push(receiver.customersInfo.customersInfoID)
            )
        }
        if (this.state.senders !== null) {
            this.state.senders.map((sender) =>
                searchModel.SenderId.push(sender.customersInfo.customersInfoID)
            )
        }
         
        if (this.state.selectedkalas !== null) {
            this.state.selectedkalas.map((selectedkala) =>
                searchModel.kalaId.push(selectedkala.kalaID)
            )
        }

        this.props.showSpinner();
        axios.post('api/LoadApi/SearchBeforeLoadAgent', searchModel)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({loadsSearchResult: res.data});
                this.props.showAlert(this.state.loadsSearchResult.length.toString() + " مورد یافت شد", "success");
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    }; 
    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        let errorInputs = [];

        if (this.state.Bastebandy === null || this.state.Bastebandy === "") {
            error.push("انتخاب  بسته‌بندی الزامی میباشد.");
            errorInputs.push("Bastebandy");
        }

        if ((this.state.bastebandyNumber === null || toEnglishNumbers(this.state.bastebandyNumber) === 0 || this.state.bastebandyNumber === "" || this.state.bastebandyNumber === undefined || toEnglishNumbers(this.state.bastebandyNumber) === "0") && this.state.Bastebandy && this.state.Bastebandy.BastebandyID !== 1) {
            error.push('وارد كردن تعداد بسته الزامی میباشد');
            errorInputs.push("bastebandyNumber");
        }

        if (this.state.cargoRange === null) {
            error.push('وارد كردن محدوده رزرو الزامی میباشد');
            errorInputs.push("cargoRange");
        }
        // if (this.state.selectedLoaderTypes.length < 1) {
        //     error.push("انتخاب نوع کشنده الزامی میباشد");
        //     errorInputs.push("selectedLoaderTypes");
        // }
        if (this.state.freighterNumber === null || toEnglishNumbers(this.state.freighterNumber) === 0) {
            error.push("وارد كردن تعداد کامیون الزامی میباشد");
            errorInputs.push("freighterNumber");
        }
        //if ((this.state.kalaValue === null || toEnglishNumbers(this.state.kalaValue) === 0)) {
        //    error.push("وارد كردن ارزش محموله الزامی میباشد");
        //    errorInputs.push("kalaValue");
        //}

        if (this.state.Tel === null || this.state.Tel === "" || this.state.Tel === '') {
            error.push("وارد كردن شماره تماس الزامي میباشد");
            errorInputs.push("Tel");
        }
        if ((this.state.kalaWeight === null || toEnglishNumbers(this.state.kalaWeight) === 0)) {
            error.push("وارد كردن وزن محموله الزامی میباشد");
            errorInputs.push("kalaWeight");
        }
        if ((this.state.TotalPrice === null || this.state.TotalPrice === "" || toEnglishNumbers(this.state.TotalPrice) === 0)) {
            error.push("وارد كردن کل کرایه الزامی میباشد");
            errorInputs.push("cargoRent");
        }

        if (this.state.kala === null || this.state.kala === "") {
            error.push("انتخاب نوع محموله الزامی میباشد.");
            errorInputs.push("kala");
        }
        if (this.props.memberType.role === 'ProductOwnerAdmin') {
            if ((this.state.TransportationCompany === null || this.state.TransportationCompany === "")) {
                error.push("انتخاب شركت  حمل و نقل الزامی میباشد");
                errorInputs.push("TransportationCompany");
            }
        }
         
        //if (this.state.isPishElamBar) {
        //    if (this.state.pishElamBarName === null || this.state.pishElamBarName === '') {
        //        error.push('وارد كردن نام پیش اعلام بار الزامی میباشد.');
        //        errorInputs.push("pishElamBarName");
        //    }
        //}
         
       
        
            // if (this.state.sender === "" || this.state.sender === null) {
            //     error.push("انتخاب فرستنده الزامی میباشد");
            //     errorInputs.push("sender");
            // }
            // if (this.state.receiver === "" || this.state.receiver === null) {
            //     error.push("انتخاب گیرنده الزامی میباشد");
            //     errorInputs.push("receiver");
            // }
            // if (this.state.senderAddress === "" || this.state.senderAddress === null) {
            //     error.push("وارد كردن آدرس فرستنده الزامی میباشد");
            //     errorInputs.push("senderAddress");
            // }
            // if (this.state.receiverAddress === "" || this.state.receiverAddress === null) {
            //     error.push("انتخاب آدرس گیرنده الزامی میباشد");
            //     errorInputs.push("receiverAddress");
            // }
            // if (this.state.receiverAddress === this.state.senderAddress) {
            //     error.push("آدرس گیرنده نمی‌تواند با آدرس فرستنده برابر باشد");
            //     errorInputs.push("receiverAddress");
            //     errorInputs.push("senderAddress");
            // }
         
        if (this.state.cargoSource === null || this.state.cargoSource === "" || this.state.cargoSource === undefined || this.state.cargoDestination === null || this.state.cargoDestination === undefined || this.state.cargoDestination === "") {
            error.push("وارد كردن مبدا و مقصد الزامی میباشد");
            errorInputs.push("cargoSource");
        }
        if (this.state.cargoDistance === null || this.state.cargoDistance === "" || this.state.cargoDistance === undefined || this.state.cargoDuration === null || this.state.cargoDuration === undefined || this.state.cargoDuration === "") {
            error.push("لطفا دوباره مسیریابی کنید");
            errorInputs.push("cargoDuration");
        }

        this.setState({errors: error, errorInputs: errorInputs});
        if (error.length === 0) {
            this.submitForm();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };
    submitForm = () => {
        let loaderTypeIds = []; 

        for (let i = 0; i < this.state.selectedLoaderTypes.length; i++) {
            loaderTypeIds.push(this.state.selectedLoaderTypes[i].id);
        } 
         
       

        const model = {
             
            
         
            SenderCustomerAddressId: this.state.senderAddress ? this.state.senderAddress.id : "0",
            ReceiverCustomerAddressId: this.state.receiverAddress ? this.state.receiverAddress.id : "0", 
            KalaId:  this.state.kala.id ,
            KalaValue: (this.state.kalaValue !== null && this.state.kalaValue !== undefined && this.state.kalaValue !== "") ? toEnglishNumbers(this.state.kalaValue):null,
            Tel: this.state.Tel   ,
            KalaWeight: toEnglishNumbers(this.state.kalaWeight),
            BastebandyId: this.state.Bastebandy.id,
            BastebandyNumber: toEnglishNumbers(this.state.bastebandyNumber),
            CargoRent: toEnglishNumbers(this.state.cargoRent),
            FreighterNumber: toEnglishNumbers(this.state.freighterNumber),
            CargoSource: this.state.cargoSource,
            CargoDestination: this.state.cargoDestination,
            CargoSourceLat: toEnglishNumbers(this.state.cargoSourceLat),
            CargoSourceLong: toEnglishNumbers(this.state.cargoSourceLong),
            CargoDestinationLat: toEnglishNumbers(this.state.cargoDestinationLat),
            CargoDestinationLong: toEnglishNumbers(this.state.cargoDestinationLong),
            CargoDuration: this.state.cargoDuration,
            CargoDistance: this.state.cargoDistance,
            Description: toEnglishNumbers(this.state.description), 
            CargoRange: toEnglishNumbers(this.state.cargoRange),
            SourceAddress: this.state.SourceAddress,
            SourcePostalcode: this.state.SourcePostalcode,
            DestinationAddress:this.state.DestinationAddress,
            DestinationPostalcode:this.state.DestinationPostalcode,
            CompanyPrice:this.state.CompanyPrice,
            SazmanPrice:this.state.SazmanPrice,
            TotalPrice:this.state.TotalPrice,
            Bimeprice:this.state.Bimeprice, 
            LoaderTypeIds: loaderTypeIds,
          
            TransportationCompanyId:null
            //IsPishElamBar: this.state.isPishElamBar,
            //PishElamBarName: toEnglishNumbers(this.state.pishElamBarName),
          
        };
        if (this.props.memberType.role === 'ProductOwnerAdmin' )
            model.TransportationCompanyId = (this.state.TransportationCompany !== null && this.state.TransportationCompany !== undefined) ? this.state.TransportationCompany.transportationCompanyId : null
        this.props.showSpinner(); 
        axios.post('/api/v1/Cargo/AddCargo', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    //this.props.showAlert("اعلام بار با شناسه " + res.data + " با موفقیت ثبت شد", "success");
                    this.props.showAlert(res.data.data.message, "success");
                   // this.props.history.push('/Loads/Detail/' + res.data);
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
     
     

    reset = () => {
        this.props.closeSweetAlert();
        this.setState({ 
            searchValue: "",
            sender: null,
            senderAddress: null,
            receiver: null,
            receiverAddress: null, 
           
            cargoRange: 2000,
            kalaValue: null,
            Tel: "",
            kala: null,
            Bastebandy: null,
            freighterNumber: null,
            bastebandyNumber: 1, 
            kalaWeight: null, 
            cargoRent: null, 
            description: null,
            selectedLoaderTypes: [],
            cargoSource: "", 
            cargoDestination: "",
            cargoDistance: "",
            cargoDuration: "",
            cargoSourceLat: "",
            cargoSourceLong: "",
            cargoDestinationLat: "",
            cargoDestinationLong: "",
            isPishElamBar: false,
            pishElamBarName: "",

            SourceAddress:"",
            SourcePostalcode:"",
            DestinationAddress:"",
            DestinationPostalcode:"",
            CompanyPrice:0,
            TotalPrice:0,
            sazmanprice:0,
            Bimeprice:0,
            
            errors: [], 
            FutureDate: utils('fa').getToday(),
            FutureMinute: "00",
            FutureHour: "00",
        });
    };

    loadProvinces = () => {
        this.props.showSpinner();
        axios.get('api/HelperApi/GetProvinces')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({provinces: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    
    selectHandleChange = (event, value, name) => {
        if (name === "sender") {
         
            if (value !== undefined && value !== null) {
                this.setState({ senderAddress: null },
                    () => this.loadSenderAddresses(value.id, null));
            }
            else {
                this.setState({
                    senderAddress: null,
                    senderAddresses: [],
                    cargoSource: "",
                    cargoSourceLat: "",
                    cargoSourceLong: "",
                    cargoDistance: "",
                    cargoDuration: "",
                })
            }

        }
        else if (name === "senderAddress") {
            if (value !== undefined && value !== null) {
                this.setState({ cargoSource: value.cityBol ? value.cityBol.cityName : value.cityName },
                () => this.getOriginGeocode());
            }
            else {
                this.setState({

                    cargoDestination: "",
                    cargoDestinationLat: "",
                    cargoDestinationLong: "",
                    cargoDistance: "",
                    cargoDuration: "",
                })
            }
        }
        else if (name === "receiver") {
            if (value !== undefined && value !== null) {
            this.setState({receiverAddress: null},
                () => this.loadReceiverAddresses(value.id, null));
            }
            else {
                this.setState({
                    receiverAddress: null,
                    receiverAddresses: [],
                    cargoDestination: "",
                    cargoDestinationLat: "",
                    cargoDestinationLong: "",
                    cargoDistance: "",
                    cargoDuration: "",
                })
            }
        }
        else if (name === "receiverAddress") {
            if (value !== undefined && value !== null) {
                this.setState({ cargoDestination: value.cityBol ? value.cityBol.cityName : value.cityName },
                () => this.getDestinationGeocode());
            }
            else {
                this.setState({
                    
                    cargoDestination: "",
                    cargoDestinationLat: "",
                    cargoDestinationLong: "",
                    cargoDistance: "",
                    cargoDuration: "",
                })
            }
        }
        
             

        this.setState({[name]: value });
    };

    OptionsMenuClick = (event, id) => {
        this.setState({ [id]: event.currentTarget });
    };
    OptionsMenuClose = (id) => {
        this.setState({ [id]: null });
    };
    openCustomerModal = (modalName, id) => {
        if (modalName === "addCustomerModal" || modalName === "manageCustomerModal") {
            if (this.state.provinces.length === 0) {
                this.loadProvinces();
            }
        }

        if (modalName === "editCustomerModal" || modalName === "manageCustomerModal") {
            if (id === "receiverOptionsMenu") {
                this.state.currentCustomer = this.state.receiver;
            } else if (id === "senderOptionsMenu") {
                this.state.currentCustomer = this.state.sender;
            }
        }

        this.setState({
            [modalName]: true,
            [id]: null
        });
    }
    closeModal = (modalName) => {
        if (modalName === "addCustomerModal") {
            this.GetCustomerByTransportationCompanyId();
        }
        this.setState({ [modalName]: false });
    };
    GetAllTransportationCompany = () => {
        let api = '';
        //if (this.props.memberType.role === 'ProductOwnerAdmin' )
        //    api = 'TransportationCompanyUser/GetByUserId'
        //else
            api = 'TransportationCompany/GetAll'
        //axios.get('/api/v1/TransportationCompanyUser/GetByUserId')
        axios.get('/api/v1/' + api)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ TransportationCompanyList: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3> اعلام بار</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>
                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                            {/* {(this.props.memberType.role === 'TransportationCompanyAdmin') &&
                            <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                                        <div className="w-md-25 w-100 mx-1 d-flex align-items-center">
                                            <Button
                                                className="addCargoSettingButtons m-1"
                                                outline color="primary" size="sm"
                                                aria-controls="sender-menu"
                                                aria-haspopup="true"
                                                aria-expanded={this.state.senderOptionsMenu ? 'true' : undefined}
                                                onClick={(event) => this.OptionsMenuClick(event, 'senderOptionsMenu')}
                                            >
                                                <i className="fa fa-cog" aria-hidden="true" />
                                            </Button>
                                            <Menu
                                                id="sender-menu"
                                                MenuListProps={{ 'aria-labelledby': 'fade-button' }}
                                                anchorEl={this.state.senderOptionsMenu}
                                                open={this.state.senderOptionsMenu}
                                                onClose={() => this.OptionsMenuClose('senderOptionsMenu')}
                                            >
                                                <MenuItem onClick={() => this.openCustomerModal('addCustomerModal', 'senderOptionsMenu')}>ایجاد فرستنده</MenuItem>
                                                {this.state.sender != null ?
                                                    <>
                                                        <MenuItem onClick={() => this.openCustomerModal('editCustomerModal', 'senderOptionsMenu')}>ویرایش اطلاعات فرستنده</MenuItem>
                                                        <MenuItem onClick={() => this.openCustomerModal('manageCustomerModal', 'senderOptionsMenu')}>مدیریت آدرس‌های فرستنده</MenuItem>
                                                    </>
                                                    :
                                                    null
                                                }
                                                <MenuItem onClick={() => this.openCustomerModal('manageCustomersModal', 'senderOptionsMenu')}>مدیریت مشتریان</MenuItem>
                                            </Menu>
                                            <FormGroup className="w-100">
                                                <Label>فرستنده (اختیاری):</Label>
                                                <Autocomplete
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="sender"
                                                    options={this.state.customer}
                                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                    value={this.state.sender}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "sender")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                        </div>

                                        {/* errors={this.state.errorInputs.includes("senderAddress")}*/}
                                     {/*}   <FormGroup className="w-md-25 w-100 mx-1">
                                            <Label>آدرس فرستنده:</Label>
                                            <Autocomplete
                                                clearText={"حذف"}
                                                closeText={"بستن"}
                                                noOptionsText={"در حال دریافت اطلاعات.."}
                                                openText={"باز کردن"}
                                                className="react-select__control"
                                                id="senderAddress"
                                                options={this.state.senderAddresses}
                                                getOptionLabel={(option) => option.address + ' (کد پستی: ' + option.postalCode + ')'}
                                                value={this.state.senderAddress}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "senderAddress")}
                                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                            />
                                        </FormGroup>

                                        <div className="w-md-25 w-100 mx-1 d-flex align-items-center">
                                            <Button
                                                className="addCargoSettingButtons m-1"
                                                outline color="primary" size="sm"
                                                aria-controls="sender-menu"
                                                aria-haspopup="true"
                                                aria-expanded={this.state.receiverOptionsMenu ? 'true' : undefined}
                                                onClick={(event) => this.OptionsMenuClick(event, 'receiverOptionsMenu')}
                                            >
                                                <i className="fa fa-cog" aria-hidden="true" />
                                            </Button>
                                            <Menu
                                                id="sender-menu"
                                                MenuListProps={{ 'aria-labelledby': 'fade-button', }}
                                                anchorEl={this.state.receiverOptionsMenu}
                                                open={this.state.receiverOptionsMenu}
                                                onClose={() => this.OptionsMenuClose('receiverOptionsMenu')}
                                            >
                                                <MenuItem onClick={() => this.openCustomerModal('addCustomerModal', 'receiverOptionsMenu')}>ایجاد گیرنده</MenuItem>
                                                {this.state.receiver != null ?
                                                    <>
                                                        <MenuItem onClick={() => this.openCustomerModal('editCustomerModal', 'receiverOptionsMenu')}>ویرایش اطلاعات گیرنده</MenuItem>
                                                        <MenuItem onClick={() => this.openCustomerModal('manageCustomerModal', 'receiverOptionsMenu')}>مدیریت آدرس‌های گیرنده</MenuItem>
                                                    </>
                                                    :
                                                    null
                                                }
                                                <MenuItem onClick={() => this.openCustomerModal('manageCustomersModal', 'receiverOptionsMenu')}>مدیریت مشتریان</MenuItem>
                                            </Menu>
                                            <FormGroup className="w-100" >
                                                <Label>گیرنده (اختیاری):</Label>
                                                <Autocomplete
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="receiver"
                                                    options={this.state.customer}
                                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode + ')'}
                                                    value={this.state.receiver}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "receiver")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                        </div>

                                        <FormGroup className="w-md-25 w-100 mx-1">
                                            <Label>آدرس گیرنده:</Label>
                                            <Autocomplete
                                                clearText={"حذف"}
                                                closeText={"بستن"}
                                                noOptionsText={"در حال دریافت اطلاعات.."}
                                                openText={"باز کردن"}
                                                className="react-select__control"
                                                id="receiverAddress"
                                                options={this.state.receiverAddresses}
                                                getOptionLabel={(option) => option.address + ' (کد پستی: ' + option.postalCode + ')'}
                                                value={this.state.receiverAddress}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "receiverAddress")}
                                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                            />
                                        </FormGroup>
                                </div>
                                } */}
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*مبدا</Label>
                                        <Input value={this.state.cargoSource} innerRef={this.cargoSource} placeholder=" "
                                               onChange={(e) => this.setState({cargoSource: e.target.value},
                                                   () =>  {if (this.state.iranmap) this.getCityOrigin()})}/>
                                </FormGroup>
                                <FormGroup className="w-md-20 w-100 px-1">
                                            <Label>*کد پستی محل بارگیری</Label>
                                        <Input maxLength={10} value={ (this.state.SourcePostalcode)}
                                            onChange={(e) => this.setState({ SourcePostalcode: e.target.value  })}  />
                                </FormGroup>
                                <FormGroup className="w-md-30 w-100 px-1">
                                            <Label>*آدرس محل بارگیری</Label>
                                        <Input value={ (this.state.SourceAddress)}
                                            onChange={(e) => this.setState({ SourceAddress: e.target.value  })} />
                                </FormGroup>
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*مقصد</Label>
                                        <Input value={this.state.cargoDestination} innerRef={this.cargoDestination} placeholder=" "
                                               onChange={(e) => this.setState({cargoDestination: e.target.value},
                                                   () =>  {if (this.state.iranmap) this.getCityDestination()})}/>
                                </FormGroup>
                                <FormGroup className="w-md-20 w-100 px-1">
                                            <Label>*کد پستی محل تخلیه</Label>
                                        <Input  maxLength={10}value={ (this.state.DestinationPostalcode)}
                                            onChange={(e) => this.setState({ DestinationPostalcode: e.target.value  })} />
                                </FormGroup>
                                <FormGroup className="w-md-30 w-100 px-1">
                                            <Label>*آدرس محل تخلیه</Label>
                                        <Input value={ (this.state.DestinationAddress)}
                                            onChange={(e) => this.setState({ DestinationAddress: e.target.value  })} />
                                </FormGroup> 
                                <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>شماره تماس گیرنده</Label>
                                        <Input value={ (this.state.Tel)}
                                            onChange={(e) => this.setState({ Tel: e.target.value  })} />
                                </FormGroup>
                                </div>
                                
                                

                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                
                             <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*نوع محموله:</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="kala"
                                            groupBy={(option) => option.kalaDesc}
                                            options={this.state.kalas}
                                            getOptionLabel={(option) => option.kalaDesc}
                                            value={this.state.kala}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                        />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>*بسته‌بندی:</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="Bastebandy"
                                            options={this.state.Bastebandys}
                                            groupBy={(option) => option.name}
                                            getOptionLabel={(option) => option.name}
                                            value={this.state.Bastebandy}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "Bastebandy")}
                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                        />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>ارزش محموله</Label>
                                        <Input value={toCurrency(this.state.kalaValue)}
                                            onChange={(e) => this.setState({ kalaValue: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                                <Label>*وزن محموله (کیلوگرم)</Label>
                                                <Input value={toCurrency(this.state.kalaWeight)}
                                                       onChange={(e) => this.setState({kalaWeight: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                                    </FormGroup>
                                    <FormGroup className="w-md-20 w-100 px-1">
                                            <Label>*کل کرایه (تومان)</Label>
                                        <Input value={toCurrency(this.state.TotalPrice)} maxLength={14}
                                                   onChange={(e) => this.setState({TotalPrice: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                                    </FormGroup>
                                    
                                    <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>کشنده‌های انتخاب‌شده:</Label>
                                        <Autocomplete
                                            multiple
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="selectedLoaderTypes"
                                            options={this.state.loaderTypes}
                                            groupBy={(option) => option.loaderTypeName}
                                            getOptionLabel={(option) => option.loaderTypeName + " " + option.loaderTypeDesc}
                                            value={this.state.selectedLoaderTypes}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedLoaderTypes")}
                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                        />
                                    </FormGroup>
                                    <FormGroup className="w-md-60 w-100 px-1">
                                        <Label>شرح بار</Label>
                                        <Input value={this.state.description} type="textarea"
                                               onChange={(e) => this.setState({description: e.target.value})}/>
                                    </FormGroup> 
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                {(this.props.memberType.role === 'ProductOwnerAdmin' ) &&
                                    <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                        <FormGroup className="w-md-30 w-100 px-1">
                                            <Label>*شركت حمل و نقل</Label>
                                            <Autocomplete
                                                clearText={"حذف"}
                                                closeText={"بستن"}
                                                noOptionsText={"در حال دریافت اطلاعات.."}
                                                openText={"باز کردن"}
                                                className="react-select__control"
                                                id="TransportationCompany"
                                                options={this.state.TransportationCompanyList}
                                                getOptionLabel={(option) => option.transportationCompanyName}
                                                value={this.state.TransportationCompany}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "TransportationCompany")}
                                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                            />
                                        </FormGroup>
                                    </div>}
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12"  >
                        <Card >
                            <CardBody className="d-flex flex-column">
                                
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                                            
                                            <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>مدت زمان</Label>
                                        <Input value={this.state.cargoDuration} readOnly/>
                                            </FormGroup>
                                            <FormGroup className="w-md-20 w-100 px-1">
                                        <Label>فاصله</Label>
                                        <Input value={this.state.cargoDistance} readOnly/>
                                            </FormGroup> 
                                            <FormGroup className="w-md-20 w-100 mx-1">
                                                <Label>عرض جغرافیایی مبدا</Label>
                                                <Input value={this.state.cargoSourceLat} placeholder="مبدا انتخاب نشده‌است" readOnly />
                                            </FormGroup>
                                            <FormGroup className="w-md-20 w-100 mx-1">
                                                <Label>طول جغرافیایی مبدا</Label>
                                                <Input value={this.state.cargoSourceLong} placeholder="مبدا انتخاب نشده‌است" readOnly />
                                            </FormGroup>
                                            <FormGroup className="w-md-20 w-100 mx-1">
                                                <Label>عرض جغرافیایی مقصد</Label>
                                                <Input value={this.state.cargoDestinationLat} placeholder="مقصد انتخاب نشده‌است" readOnly />
                                            </FormGroup>
                                            <FormGroup className="w-md-20 w-100 mx-1">
                                                <Label>طول جغرافیایی مقصد</Label>
                                                <Input value={this.state.cargoDestinationLong} placeholder="مقصد انتخاب نشده‌است" readOnly />
                                            </FormGroup>
                                    </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                 
                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column">
                                {this.state.errors.length === 0 ?
                                    null
                                    :
                                    <div>
                                        {(this.state.errors.map((error, i) => {
                                            return (
                                                <Alert color="danger" key={i}>{error}</Alert>
                                            )
                                        }))}
                                    </div>
                                }
                                

                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center mt-4">
                                    <Button outline color="primary" className="mx-3 my-md-0 my-1"
                                            onClick={() => this.props.showSweetAlert("", "آیا از صحت اطلاعات واردشده اطمینان دارید؟", "warning", this.validateInputData)}>
                                        ثبت
                                    </Button>

                                    <Button outline color="secondary" className="mx-3 my-md-0 my-1"
                                            onClick={() => this.props.showSweetAlert("", "آیا می‌خواهید تمام اطلاعات واردشده را پاک کنید؟", "danger", this.reset)}>
                                        پاک کردن
                                    </Button>

                                    <Link to={"/"} type="button">
                                        <Button outline color="warning" className="mx-3 my-md-0 my-1">
                                           صفحه اصلي
                                        </Button>
                                    </Link>
                                </div>

                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.copyLoadModal} toggle={() => this.closeModal("copyLoadModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("copyLoadModal")}>
                        پیش اعلام بار
                    </ModalHeader>
                    <ModalBody>
                        <Table
                            tableHeaders={[
                                "نام",
                                "مدت زمان گذشته",
                                "تاریخ",
                                "ساعت",
                                "نوع محموله",
                                "فرستنده",
                                "گیرنده",
                                "مبدا",
                                "مقصد",
                                "تعداد",
                                "کرایه",
                                "انتخاب",
                                "حذف"
                            ]}

                            tableRow={this.state.preLoads}

                            tableData={[
                                preLoad => {
                                    return preLoad.load.pishElamBarName;
                                },
                                preLoad => {
                                    return "(" + preLoad.prettyShamsiLoadDate + ")";
                                },
                                preLoad => {
                                    return preLoad.loadDate;
                                },
                                preLoad => {
                                    return preLoad.loadTime;
                                },
                                preLoad => {
                                    return preLoad.load.kala.kalaDesc;
                                },
                                preLoad => {
                                    return preLoad.load.customerAddress !== null && preLoad.load.customerAddress.customersInfo.name;
                                },
                                preLoad => {
                                    return preLoad.load.customerAddress1 !== null && preLoad.load.customerAddress1.customersInfo.name;
                                },
                                preLoad => {
                                    return preLoad.load.loadSource;
                                },
                                preLoad => {
                                    return preLoad.load.loadDestination;
                                },
                                preLoad => {
                                    return preLoad.load.loadNumber;
                                },
                                preLoad => {
                                    return toCurrency(preLoad.load.cargoRent);
                                },
                                preLoad => {
                                    return (
                                        <Button color="secondary" size="sm" outline
                                                onClick={() => {this.replaceData(preLoad); this.setState({copyLoadModal: false})}}>
                                            انتخاب
                                        </Button>
                                    );
                                },
                                preLoad => {
                                    return (
                                        <Button color="danger" size="sm" outline
                                                onClick={() => this.props.showSweetAlert("آیا این پیش اعلام بار حذف شود؟", "", "danger", () => this.delete(preLoad.load.loadID))}>
                                            حذف
                                        </Button>
                                    );
                                }
                            ]}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.loadsSearchModal} toggle={() => this.closeModal("loadsSearchModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("loadsSearchModal")}>
                        اعلام بارهای قبلی
                    </ModalHeader>
                    <ModalBody>
                        <div className="d-flex flex-md-row flex-column w-100 justify-content-md-between justify-content-center">
                            <FormGroup className="w-md-30 w-100 mx-1">
                                <Label>از تاریخ</Label>
                                <DatePicker
                                    value={this.state.fromDate}
                                    onChange={(newDate) => this.setState({fromDate: newDate})}
                                    shouldHighlightWeekends
                                    inputClassName="form-control"
                                    locale="fa"
                                    calendarClassName="calendar"
                                    colorPrimary={Config.color}
                                    calendarPopperPosition={'bottom'}
                                />
                            </FormGroup>

                            <FormGroup className="w-md-30 w-100 mx-1">
                                <Label>تا تاریخ</Label>
                                <DatePicker
                                    value={this.state.toDate}
                                    onChange={(newDate) => this.setState({toDate: newDate})}
                                    shouldHighlightWeekends
                                    inputClassName="form-control"
                                    locale="fa"
                                    calendarClassName="calendar"
                                    colorPrimary={Config.color}
                                    calendarPopperPosition={'bottom'}
                                />
                            </FormGroup>

                            
                        </div>

                        <div className="d-flex flex-md-row flex-column w-100 justify-content-md-between justify-content-center">
                            <FormGroup className="w-md-30 w-100 mx-1">
                                <Label>فرستنده‌ها</Label>
                                <Autocomplete
                                    multiple
                                    clearText={"حذف"}
                                    closeText={"بستن"}
                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                    openText={"باز کردن"}
                                    className="react-select__control"
                                    id="senders"
                                    options={this.state.customer}
                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode +')'}
                                    value={this.state.senders}
                                    onChange={(e, v) => this.selectHandleChange(e, v, "senders")}
                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                />
                            </FormGroup>

                            <FormGroup className="w-md-30 w-100 mx-1">
                                <Label>گیرنده‌ها</Label>
                                <Autocomplete
                                    multiple
                                    clearText={"حذف"}
                                    closeText={"بستن"}
                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                    openText={"باز کردن"}
                                    className="react-select__control"
                                    id="receivers"
                                    options={this.state.customer}
                                    getOptionLabel={(option) => option.customerFullName + ' (' + option.meliCode +')'}
                                    value={this.state.receivers}
                                    onChange={(e, v) => this.selectHandleChange(e, v, "receivers")}
                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                />
                            </FormGroup>

                            <FormGroup className="w-md-30 w-100 mx-1">
                                <Label>نوع محموله‌ها</Label>
                                <Autocomplete
                                    multiple
                                    clearText={"حذف"}
                                    closeText={"بستن"}
                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                    openText={"باز کردن"}
                                    className="react-select__control"
                                    id="selectedkalas"
                                    options={this.state.kalas}
                                    getOptionLabel={(option) => option.kalaDesc}
                                    value={this.state.selectedkalas}
                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedkalas")}
                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                />
                            </FormGroup>
                        </div>

                        <div className="d-flex mb-2 mt-4 justify-content-center align-items-center">
                            <Button color="primary" className="btn-lg mx-2" onClick={() => this.searchLoad()}>
                                جستجو
                            </Button>
                        </div>

                        <Table
                            tableHeaders={[
                                "مدت زمان گذشته",
                                "تاریخ",
                                "ساعت",
                                "نوع محموله",
                                "فرستنده",
                                "گیرنده",
                                "مبدا",
                                "مقصد",
                                "تعداد",
                                "کرایه",
                                "انتخاب"
                            ]}

                            tableRow={this.state.loadsSearchResult}

                            tableData={[
                                load => {
                                    return "(" + load.prettyDate + ")";
                                },
                                load => {
                                    return load.loadDate;
                                },
                                load => {
                                    return load.loadTime;
                                },
                                load => {
                                    return load.load.kala.kalaDesc;
                                },
                                load => {
                                    return load.load.customerAddress!==null ? load.load.customerAddress.customersInfo.name : '';
                                },
                                load => {
                                    return load.load.customerAddress !== null ? load.load.customerAddress1.customersInfo.name : '';
                                },
                                load => {
                                    return load.load.loadSource;
                                },
                                load => {
                                    return load.load.loadDestination;
                                },
                                load => {
                                    return load.load.loadNumber;
                                },
                                load => {
                                    return load.load.cargoRent;
                                },
                                load => {
                                    return (
                                        <Button color="secondary" size="sm" outline
                                                onClick={() => {this.replaceData(load); this.setState({loadsSearchModal: false})}}>
                                            انتخاب
                                        </Button>
                                    );
                                },
                            ]}
                        />
                    </ModalBody>
                </Modal>


                <Modal isOpen={this.state.addCustomerModal} size="xlg" toggle={() => this.closeModal("addCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("addCustomerModal")}>
                        افزودن مشتری جدید
                    </ModalHeader>
                    <ModalBody>
                        <AddCustomerModal
                            provinces={this.state.provinces}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("addCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.editCustomerModal} size="xlg" toggle={() => this.closeModal("editCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("editCustomerModal")}>
                        ویرایش مشتری
                    </ModalHeader>
                    <ModalBody>
                        <EditCustomer
                            selectedCustomerToEdit={this.state.currentCustomer}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("editCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.manageCustomersModal} size="xlg" toggle={() => this.closeModal("manageCustomersModal")}>
                    <ModalHeader toggle={() => this.closeModal("manageCustomersModal")}>
                        مدیریت مشتریان
                    </ModalHeader>
                    <ModalBody>
                        <Customer
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("manageCustomersModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default AddCargo;